import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import config from "../../../config";
import MainCard from "../../../components/Card/MainCard";

export default function AnimalTypes() {
  const [animalTypes, setAnimalTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("goat");
  const [editId, setEditId] = useState(null);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchAnimalTypes();
  }, []);

  const fetchAnimalTypes = async () => {
    const res = await api.get(`/animal-types`);
    setAnimalTypes(res.data);
  };

  const handleSave = async () => {
    if (!name || !category) return;

    if (editId) {
      await api.put(`/animal-types/${editId}`, { name, category });
    } else {
      await api.post(`/animal-types`, { name, category });
    }

    setName("");
    setCategory("goat");
    setEditId(null);
    setShowModal(false);
    fetchAnimalTypes();
  };

  const handleDelete = async (id) => {
    await api.delete(`/animal-types/${id}`);
    fetchAnimalTypes();
  };

  const handleEdit = (type) => {
    setEditId(type.id);
    setName(type.name);
    setCategory(type.category);
    setShowModal(true);
  };

  const columns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Category", selector: (row) => row.category, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Button size="sm" variant="warning" onClick={() => handleEdit(row)}>
            Edit
          </Button>{" "}
          <Button
            size="sm"
            variant="danger"
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="my-3">
        <Button onClick={() => setShowModal(true)}>Add Animal Type</Button>
      </div>
      <MainCard title="Animal Types List">
        <DataTable
          columns={columns}
          data={animalTypes}
          pagination
          className="mt-3"
        />
      </MainCard>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? "Edit" : "Add"} Animal Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Category</Form.Label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="goat">Goat</option>
                <option value="pig">Pig</option>
                <option value="sheep">Sheep</option>
              </select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editId ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
